import {
  FeatureFlagContext,
  FeatureFlags,
} from 'contexts/feature-flag-context';
import React, { ReactNode, useCallback, useContext, useState } from 'react';

import { setSentryFeatureFlags } from 'utils/sentryFlags';

interface FeatureFlagContextProviderProps {
  children: ReactNode;
}

export function FeatureFlagContextProvider({
  children,
}: FeatureFlagContextProviderProps) {
  const { featureFlags: defaultFeatureFlags } = useContext(FeatureFlagContext);
  const [featureFlags, setFeatureFlags] =
    useState<FeatureFlags>(defaultFeatureFlags);
  const setFlags = useCallback((flags: FeatureFlags) => {
    setFeatureFlags(flags);
    // The brand configuration decides these, so an issue that only one
    // customer sees usually differs by exactly this object.
    setSentryFeatureFlags(flags);
  }, []);

  return (
    <FeatureFlagContext.Provider value={{ featureFlags, setFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
